import React, { useState, useEffect } from 'react';

const TypingEffect = ({ text, speed, color, fontFamily, fontSize, onComplete }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [index, setIndex] = useState(0);
    const [removing, setRemoving] = useState(false);

    useEffect(() => {
        let timeoutId;

        if (!removing) {
            // Typing phase
            if (index < text.length) {
                timeoutId = setTimeout(() => {
                    setDisplayedText((prev) => prev + text.charAt(index));
                    setIndex(index + 1);
                }, speed);
            } else {
                // After typing is complete, start removing after a brief delay
                timeoutId = setTimeout(() => {
                    setRemoving(true);
                }, 500); // Delay before removing
            }
        } else {
            // Removing phase
            if (displayedText.length > 0) {
                timeoutId = setTimeout(() => {
                    setDisplayedText((prev) => prev.slice(0, -1));
                }, speed);
            } else if (onComplete) {
                onComplete();
            }
        }

        return () => clearTimeout(timeoutId);
    }, [index, text, speed, removing, displayedText, onComplete]);

    return (
        <div style={{ color: color, fontFamily: fontFamily, fontSize: fontSize }}>
            {displayedText}
        </div>
    );
};

export default TypingEffect;
